import { Button } from 'antd';
import { FunctionComponent } from 'react';

import { isRTL } from 'core/services/language';
import { Notification } from 'core/layouts/main/models/notificationModel';

import styles from './notification.module.scss';

interface NotificationItemProps {
	notification: Notification;
	onClick: (notification: Notification) => void;
}

const NotificationItem: FunctionComponent<NotificationItemProps> = ({ notification, onClick }) => {
	const title = isRTL() ? notification.translated_title?.ar : notification.translated_title?.en;
	const message = isRTL() ? notification.translated_message?.ar : notification.translated_message?.en;

	return (
		<Button
			size="middle"
			type="text"
			className={`${styles.notificationItem} ${!notification.is_read ? styles.unread : ''} mb-2`}
			onClick={() => onClick(notification)}>
			<div className={styles.content}>
				<p className="mb-0 fw-medium">{title ?? notification.title}</p>
				<p className={`mb-0 ${styles.message}`}>{message ?? notification.message}</p>
				<p className="mb-0 text-light small">{notification.created_at_human}</p>
			</div>
			{!notification.is_read && <span className={styles.dot}></span>}
		</Button>
	);
};

export default NotificationItem;
